// Icon-Set des Neuentwurfs: Linien im 24er-Raster, Farbe ueber currentColor.
//
// Ersetzt seit dem Neuentwurf alle Emojis der Oberflaeche. Ein neues Icon =
// ein Eintrag hier.

const PFADE = {
  titel: (
    <>
      <path d="M9 18V5l11-2v13" />
      <circle cx="6.5" cy="18" r="2.5" />
      <circle cx="17.5" cy="16" r="2.5" />
    </>
  ),
  interpret: (
    <>
      <rect x="9" y="3" width="6" height="11" rx="3" />
      <path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21M8.5 21h7" />
    </>
  ),
  jahr: (
    <>
      <rect x="3.5" y="5" width="17" height="15.5" rx="3" />
      <path d="M3.5 10h17M8 3v4M16 3v4M8 14h2M12 14h2M8 17h2" />
    </>
  ),
  album: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <circle cx="12" cy="12" r="2.5" />
      <path d="M12 3.5a8.5 8.5 0 0 1 8.5 8.5" />
    </>
  ),
  verlauf: (
    <>
      <path d="M3.5 12a8.5 8.5 0 1 0 2.5-6" />
      <path d="M5.5 3v3.5H9M12 8v4l3 2" />
    </>
  ),
  menue: (
    <>
      <circle cx="5.5" cy="12" r="1.3" />
      <circle cx="12" cy="12" r="1.3" />
      <circle cx="18.5" cy="12" r="1.3" />
    </>
  ),
  krone: <path d="M3.5 8l4 4 4.5-6 4.5 6 4-4-1.8 10H5.3z" />,
  play: <path d="M7 4.5v15l12.5-7.5z" />,
  pause: <path d="M8 5v14M16 5v14" />,
  skip: <path d="M5 5l9 7-9 7zM18 5v14" />,
  pfeil: <path d="M4.5 12h14M13 6.5l5.5 5.5-5.5 5.5" />,
  check: <path d="M5 12.5l4.5 4.5L19 7" />,
  x: <path d="M6 6l12 12M18 6L6 18" />,
  auge: (
    <>
      <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  schloss: (
    <>
      <rect x="5" y="10.5" width="14" height="10" rx="2.5" />
      <path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" />
    </>
  ),
  nochmal: <path d="M20 12a8 8 0 1 1-2.3-5.6M20 4v4.5h-4.5" />,
  minus: <path d="M6 12h12" />,
  loeschen: <path d="M20 6.5H9.5L4 12l5.5 5.5H20zM12.5 9.5l5 5M17.5 9.5l-5 5" />,
  einstellungen: (
    <>
      {/* Zahnrad. Vorher Kreis + Strahlen — das las sich als Sonne. */}
      <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  punkte: <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />,
  flagge: <path d="M5.5 21V3.5M5.5 4.5h12l-2.5 4 2.5 4h-12" />,
  tuer: <path d="M14 4h4.5A1.5 1.5 0 0 1 20 5.5v13a1.5 1.5 0 0 1-1.5 1.5H14M10 8l-4 4 4 4M6 12h10" />,
  handy: (
    <>
      <rect x="7" y="2.5" width="10" height="19" rx="2.5" />
      <path d="M11 18.5h2" />
    </>
  ),
  // Zwei Handys (Buzzer-Modus: jeder am eigenen). Das hintere ist nur dort
  // gezeichnet, wo das vordere es nicht verdeckt — mit Luft dazwischen.
  handys: (
    <>
      <path d="M13.25 4.4V4a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h2.4" />
      <rect x="10.25" y="6" width="9.5" height="16" rx="2.2" />
      <path d="M14 19h2" />
    </>
  ),
  plus: <path d="M12 5v14M5 12h14" />,
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5.5M12 7.6v.4" />
    </>
  ),
  zurueck: <path d="M19.5 12h-14M11 6.5L5.5 12l5.5 5.5" />,
  lautsprecher: <path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4zM15.5 9a4.2 4.2 0 0 1 0 6M18 6.5a7.8 7.8 0 0 1 0 11" />,
  personen: (
    <>
      <circle cx="9" cy="8.5" r="3.2" />
      <path d="M3 19.5c.7-3.3 3-5 6-5s5.3 1.7 6 5" />
      <circle cx="17" cy="9" r="2.6" />
      <path d="M16.5 14.6c2.3.2 3.9 1.7 4.5 4.4" />
    </>
  ),
  teilen: <path d="M12 15V3.5M7.5 8L12 3.5 16.5 8M5 12.5v6A2 2 0 0 0 7 20.5h10a2 2 0 0 0 2-2v-6" />,
  hand: (
    <path d="M8 13V5.5a1.5 1.5 0 0 1 3 0V11M11 10.5V4a1.5 1.5 0 0 1 3 0v6.5M14 10.5V5.5a1.5 1.5 0 0 1 3 0V13M17 11.5a1.5 1.5 0 0 1 3 0V14a7 7 0 0 1-7 7h-1a6 6 0 0 1-5-2.7L4.3 14.2a1.5 1.5 0 0 1 2.4-1.8L8 14" />
  ),
  computer: (
    <>
      <rect x="3" y="4.5" width="18" height="12" rx="2" />
      <path d="M8.5 20h7M12 16.5V20" />
    </>
  ),
  box: (
    <>
      <rect x="6" y="3" width="12" height="18" rx="3" />
      <circle cx="12" cy="14" r="3" />
      <circle cx="12" cy="7.5" r="1" />
    </>
  ),
  kopieren: (
    <>
      <rect x="8.5" y="8.5" width="11" height="12" rx="2" />
      <path d="M15.5 8.5V5.5a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h3" />
    </>
  ),
  muell: <path d="M4.5 7h15M10 11v6M14 11v6M6 7l1 12.5A1.5 1.5 0 0 0 8.5 21h7a1.5 1.5 0 0 0 1.5-1.5L18 7M9 7V4.5A1.5 1.5 0 0 1 10.5 3h3A1.5 1.5 0 0 1 15 4.5V7" />,
  "pfeil-runter": <path d="M6 9.5l6 6 6-6" />,
  "wlan-aus": (
    <>
      <path d="M3 3l18 18M8.5 15.5a5.5 5.5 0 0 1 5.6-1.2M5 12.5a10 10 0 0 1 4-2.6M14.5 9.8a10 10 0 0 1 4.5 2.7" />
      <circle cx="12" cy="18.5" r="1" />
    </>
  ),
  fenster: (
    <>
      <rect x="3" y="4.5" width="18" height="15" rx="2.5" />
      <path d="M3 9h18" />
    </>
  ),
  qr: (
    <>
      <rect x="3.5" y="3.5" width="6" height="6" rx="1" />
      <rect x="14.5" y="3.5" width="6" height="6" rx="1" />
      <rect x="3.5" y="14.5" width="6" height="6" rx="1" />
      <path d="M14.5 14.5h2v2M20.5 14.5v6h-6v-2" />
    </>
  ),
};

/**
 * Ein Icon aus dem Set (name: titel, interpret, jahr, album, verlauf, menue,
 * krone, play, pause, skip, pfeil, check, x, auge, schloss, nochmal, minus,
 * loeschen, einstellungen, punkte, flagge, tuer, qr, handy, handys, plus, info,
 * zurueck, lautsprecher, personen, teilen, hand, computer, box, kopieren,
 * muell, pfeil-runter, wlan-aus, fenster).
 * @category icons
 */
export function Icon({ name, size = 20, className, title }) {
  return (
    <svg
      className={["icon", className].filter(Boolean).join(" ")}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      focusable="false"
    >
      {PFADE[name]}
    </svg>
  );
}

export const ICON_NAMEN = Object.keys(PFADE);

export default Icon;
